// Data Space configuration checker

"use strict";

import { CheckDataSpaceConfigurationResponse } from "@/api/definitions";
import { AppEvents } from "./app-events";
import { Timeouts } from "@/utils/timeout";
import { Request } from "@asanrom/request-browser";
import { ApiAdminDataSpace } from "@/api/api-group-admin-data-space";
import { AuthController } from "./auth";

const CONFIG_CHECK_REQ_ID = "ds-config-check-request";

/**
 * Data Space configuration checker
 */
export class DataSpaceConfigurationChecker {
    public static ConfigCheckStatus: CheckDataSpaceConfigurationResponse = { configured: true };

    public static Initialize() {
        AppEvents.AddEventListener("auth-status-changed", this.Load.bind(this));

        this.Load();
    }

    public static Load() {
        Timeouts.Abort(CONFIG_CHECK_REQ_ID);
        Request.Abort(CONFIG_CHECK_REQ_ID);

        if (!AuthController.isAuthenticated() || !AuthController.hasPermission("admin.ds")) {
            this.ConfigCheckStatus = { configured: true };
            AppEvents.Emit("ds-config-check-updated");
        }

        Request.Pending(CONFIG_CHECK_REQ_ID, ApiAdminDataSpace.CheckDataSpaceConfiguration())
            .onSuccess((response) => {
                this.ConfigCheckStatus = response;

                AppEvents.Emit("ds-config-check-updated");
            })
            .onRequestError((err, handleErr) => {
                handleErr(err, {
                    unauthorized: () => {
                        this.ConfigCheckStatus = { configured: true };
                        AppEvents.Emit("ds-config-check-updated");
                    },
                    forbidden: () => {
                        this.ConfigCheckStatus = { configured: true };
                        AppEvents.Emit("ds-config-check-updated");
                    },
                    temporalError: () => {
                        Timeouts.Set(CONFIG_CHECK_REQ_ID, 1500, this.Load.bind(this));
                    },
                });
            })
            .onUnexpectedError((err) => {
                console.error(err);
                Timeouts.Set(CONFIG_CHECK_REQ_ID, 1500, this.Load.bind(this));
            });
    }
}
